module.exports = __webpack_public_path__ + "c7579554a3bdd20d559feb83a8922f81.pdf";